/** Coordinates approval and the write; cancellation must never start a late write. */
export async function submitSupervisorDecision(options: {
  signal: AbortSignal;
  isFresh: () => boolean;
  approve?: () => Promise<string>;
  onApproved: (token: string) => void;
  onDecisionStart: () => void;
  decide: () => Promise<void>;
}): Promise<void> {
  if (options.approve) {
    const token = await options.approve();
    if (options.signal.aborted) return;
    options.onApproved(token);
  }
  if (options.signal.aborted) return;
  if (!options.isFresh()) throw new Error("Güncel bilgiler alınamadı. İşlemi başlatmadan önce verileri yenileyin.");
  options.onDecisionStart();
  await options.decide();
}

/** Refresh is independent: neither a slow refresh nor a failed one may hide the write result. */
export async function decideAndRefresh(decide: () => Promise<void>, refresh: () => Promise<void>): Promise<void> {
  try {
    await decide();
  } finally {
    void refresh().catch(() => undefined);
  }
}

/** Server/network errors may occur after a write has committed. */
export function isDecisionOutcomeUnknown(error: unknown): boolean {
  if (!(error instanceof Error)) return true;
  const value = error as Error & { code?: unknown; errorType?: unknown };
  return typeof value.code !== "string" || ["OPERATION_OUTCOME_UNKNOWN", "NETWORK_ERROR", "INVALID_API_RESPONSE", "DATABASE_ERROR", "UNEXPECTED_ERROR", "INTEGRATION_ERROR"].includes(value.code) ||
    (typeof value.errorType === "string" && ["database_error", "unexpected_error", "integration_error"].includes(value.errorType)) || /^HTTP_5\d\d$/u.test(value.code);
}
